import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Input } from "antd";

import { Header, Nav, HamburgerMenu } from "./components";

import {
  loginUserCheck,
  logoutUser,
  spareFetchById,
  spareUpdate,
} from "../redux/actions";

class AdminEditSpare extends Component {
  constructor() {
    super();
    this.state = {
      id: "",
      brand_id: "",
      brand_title: "",
      // product_type: "",
      name: "",
      price: "",
      brand: "",
      description: "",
      file: "",
      oldFile: "",
      toggleMenu: false,
      title: "",
    };
  }

  componentWillMount() {
    this.props.loginUserCheck();
    const params = this.getParams();
    this.setState({ id: params.id });
    this.props.spareFetchById(params.id);
  }

  getParams() {
    const searchParams = new URLSearchParams(this.props.location.search);
    return {
      id: searchParams.get("id") || "",
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.spares) {
      const spare = nextProps.spares[0];
      this.setState({
        brand_id: spare.brand_id,
        brand_title: spare.brand_title,
        // product_type: spare.product_type,
        name: spare.name,
        price: spare.price,
        brand: spare.brand,
        description: spare.description,
        oldFile: spare.img,
        title: spare.name,
      });
    }
  }

  _handleMenu() {
    this.setState({ toggleMenu: !this.state.toggleMenu });
  }

  _handleLogout() {
    this.props.logoutUser();
  }

  _onHandleChange(event) {
    if (event.target.files) {
      this.setState({
        [event.target.name]: event.target.files[0],
      });
    } else {
      this.setState({
        [event.target.name]: event.target.value,
      });
    }
  }

  _onSubmit() {
    let oldFile = ""
    if (this.state.file) {
      oldFile = decodeURIComponent(this.state.oldFile.substring(70, 95));
    }
    const data = {
      brand_id: this.state.brand_id,
      brand_title: this.state.brand_title,
      // product_type: this.state.product_type,
      name: this.state.name,
      price: this.state.price,
      brand: this.state.brand,
      description: this.state.description,
      img: this.state.file,
      updated_date: new Date().getTime(),
    };
    if (this.state.name) {
      this.props.spareUpdate(this.state.id, data, oldFile);
    } else {
      alert("Please fill in a form...");
    }
  }

  render() {
    if (!this.props.user) return <div></div>;
    return (
      <div>
        <Header name={this.props.user} logout={() => this._handleLogout()} />
        <div className="admin-adddocument">
          <Nav active="spare" />
          <div
            className={this.state.toggleMenu ? "content moveover" : "content"}
          >
            <div className="content-inner">
              <HamburgerMenu onClick={() => this._handleMenu()} />
              <div className="title">
                <h2>
                  อะไหล่ : { this.state.brand_title }
                  {/* <span className="brandname">{this.state.title}</span> */}
                </h2>
              </div>
              <div className="info">
                <div className="adjust">
                  <form className="form-container">
                    <div className="photo">
                      <div className="brand-title">
                        <p>รูปสินค้า :</p>
                      </div>
                      <div className="filename">
                        <p>{this.state.file.name}</p>
                      </div>
                      <div className="photo-input">
                        <input
                          id="file"
                          type="file"
                          name="file"
                          accept="image/*"
                          hidden
                          onChange={(event) => this._onHandleChange(event)}
                        />
                        <label htmlFor="file">เลือกรูปภาพ</label>
                      </div>
                      <div className="oldphoto">
                        <img src={this.state.oldFile} alt="privilege" />
                      </div>
                    </div>
                    {/* <div className="form-item">
                      <p>ประเภท :</p>
                      <Select
                        name="product_type"
                        value={this.state.product_type}
                        onChange={(value) =>
                          this.setState({ product_type: value })
                        }
                        style={{ width: "100%" }}
                        options={[
                          {
                            value: "wall",
                            label: "แอร์ผนัง",
                          },
                          {
                            value: "hang",
                            label: "แอร์แขวน",
                          },
                          {
                            value: "four",
                            label: "แอร์สี่ทิศทาง",
                          },
                          {
                            value: "concealed",
                            label: "แอรเ์ปลือย",
                          },
                          {
                            value: "stand",
                            label: "แอร์ตู้ตั้ง",
                          },
                          {
                            value: "one_way",
                            label: "แอร์หนึ่งทิศทาง",
                          },
                        ]}
                      />
                    </div> */}
                    <div className="form-item">
                      <p>ชื่อ* :</p>
                      <Input
                        name="name"
                        value={this.state.name}
                        onChange={(event) => this._onHandleChange(event)}
                      />
                    </div>
                    <div className="form-item">
                      <p>ราคา :</p>
                      <Input
                        name="price"
                        value={this.state.price}
                        onChange={(event) => this._onHandleChange(event)}
                      />
                    </div>
                    <div className="form-item">
                      <p>ยี่ห้อ :</p>
                      <Input
                        name="brand"
                        value={this.state.brand}
                        onChange={(event) => this._onHandleChange(event)}
                      />
                    </div>
                    <div className="form-item">
                      <p>รายละเอียด :</p>
                      <Input
                        name="description"
                        value={this.state.description}
                        onChange={(event) => this._onHandleChange(event)}
                      />
                    </div>
                  </form>

                  <div
                    className="action-button"
                    style={{
                      marginBottom: "20px",
                      paddingLeft: "10px",
                      paddingTop: 20,
                    }}
                  >
                    {this.props.loading || this.state.name === "" ? (
                      <div>
                        <p style={{ textAlign: "left" }}>Loading...</p>
                      </div>
                    ) : (
                      <div>
                        <Button type="primary" onClick={() => this._onSubmit()}>
                          บันทึก
                        </Button>
                        <Button onClick={() => window.history.back()}>
                          กลับ
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ auth, spare }) => {
  return {
    user: auth.user,
    loading: spare.loading,
    spares: spare.spares,
  };
};

export default connect(mapStateToProps, {
  loginUserCheck,
  logoutUser,
  spareFetchById,
  spareUpdate,
})(AdminEditSpare);
